import { Box, IBoxProps } from "native-base";
import React from "react";

interface ScreenContainerProps extends IBoxProps {
  children: React.ReactNode;
  safeAreaMode?: "full" | "top" | "none" | "top-horizontal";
}

/**
 * A reusable container component that provides consistent screen styling
 * including theme-based background color and safe area handling
 */
const ScreenContainer: React.FC<ScreenContainerProps> = ({ children, safeAreaMode = "full", ...props }) => {
  // Determine safe area props based on mode
  const safeAreaProps = (() => {
    if (safeAreaMode === "full") {
      return { safeArea: true };
    }
    if (safeAreaMode === "top") {
      return { safeAreaTop: true };
    }
    if (safeAreaMode === "top-horizontal") {
      // This mode is for screens with bottom navigation - applies top and horizontal safe areas only
      return { safeAreaTop: true, safeAreaX: true };
    }
    return {};
  })();

  return (
    <Box
      flex={1}
      bg="primary.10" // Always use primary.10 for screen background
      {...safeAreaProps}
      {...props}
    >
      {children}
    </Box>
  );
};

export default ScreenContainer;
